<script setup lang="ts">
const store = usePrestacaoDeContaStore()
const { modalDetalhesReceita } = storeToRefs(store)

function fechar () {
  store.resetarModalDetalhesReceita()
}

const detalhesFormatados = computed(() => {
  if (!modalDetalhesReceita.value.transacao?.agrupados) { return [] }

  return modalDetalhesReceita.value.transacao.agrupados.map(item => ({
    selo: item.detalhes?.selo || '-',
    orcamento: item.detalhes?.orcamento || '-',
    valor: useStore().formatarDinheiro(item.valor, true),
    repasse: useStore().formatarDinheiro(item.repasse, true),
  }))
})

const totais = computed(() => {
  if (!modalDetalhesReceita.value.transacao?.agrupados) { return { valor: 0, repasse: 0 } }

  return modalDetalhesReceita.value.transacao.agrupados.reduce((acc, item) => {
    acc.valor += item.valor
    acc.repasse += item.repasse
    return acc
  }, { valor: 0, repasse: 0 })
})
</script>
<template>
  <CModal
    id="modalDetalhesReceita"
    :visible="store.modalDetalhesReceita.exibir"
    size="lg"
    @close="fechar"
  >
    <CModalHeader>
      <CModalTitle>Detalhes</CModalTitle>
    </CModalHeader>
    <CModalBody class="p-0">
      <div class="p-4">
        <div>Data: <b>{{ useStore().formatarData(modalDetalhesReceita.transacao?.data) }}</b></div>
        <div>Ato: <b>{{ modalDetalhesReceita.transacao?.historico }}</b></div>
      </div>

      <table class="table table-striped table-hover mb-0">
        <thead>
          <tr>
            <th>Selo</th>
            <th>Orçamento</th>
            <th>Valor</th>
            <th>Repasse</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(detalhe, index) in detalhesFormatados" :key="index">
            <td>
              <a href="#/selo/">{{ detalhe.selo }}</a>
            </td>
            <td>{{ detalhe.orcamento }}</td>
            <td>{{ detalhe.valor }}</td>
            <td>{{ detalhe.repasse }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="2" class="text-end">
              <strong>Total:</strong>
            </td>
            <td><strong>{{ useStore().formatarDinheiro(totais.valor, true) }}</strong></td>
            <td><strong>{{ useStore().formatarDinheiro(totais.repasse, true) }}</strong></td>
          </tr>
        </tfoot>
      </table>
    </CModalBody>
    <CModalFooter>
      <CButton color="secondary" @click="fechar">
        Fechar
      </CButton>
    </CModalFooter>
  </CModal>
</template>

<style scoped>
.table {
  margin-bottom: 0;
}

.table td, .table th {
  padding: 0.5rem 1rem;
}

tfoot {
  border-top: 2px solid #dee2e6;
}
</style>
